import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useProvider } from 'utils/providers/Provider';
import useModal from 'ui/partials/Modal/useModal';
import { useAdminParams } from 'utils/helpers';

import c from '../utils/constants';

export default function useDeleteDeals() {
  const queryClient = useQueryClient();
  const { hideModal } = useModal();
  const { accountId, accountUserId } = useAdminParams();
  const { state } = useProvider();
  const args = state;

  return useMutation({
    mutationFn: async (payload: string[]) => {
      const api = new Api(args);

      const data = await api.delete(
        await withAcl({
          account: {
            url: `api/v1/sales/deals`,
            payload: { ids: payload },
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/sales/deals`,
            payload: { ids: payload },
          },
        }),
      );

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([c.PIPELINES]);
      queryClient.invalidateQueries([c.DEALS, {}]);

      toastSuccess('Successfully deleted deals');
      hideModal();
    },
  });
}
